import { ApiHosts, handleResponseOld, makeGet } from '@/redux/api/helpers';
import { RelatedSearches, RelatedSearchPages } from './categoryRelatedSearches.types';

type FetchCategoryRelatedSearchTilesParams = {
    authToken: string;
    categoryIds: number[];
    concatenatedFacetIds?: string[];
    deployment: string;
};

type FetchCategoryRelatedSearchTilesResponse = {
    error: boolean;
    payload: {
        relatedSearchPages: RelatedSearchPages[];
        relatedSearches: RelatedSearches[];
    };
};

/**
 * Gets related search tiles for category pages from the new v2 endpoint
 * @function getCategoryRelatedSearchTiles
 * @category CATEGORY API
 * @param {FetchCategoryRelatedSearchTilesParams}
 * @see https://api-DEPLOYMENT.liveauctioneers.com/category-api/v2/related-searches-tiles?category-id={}
 */
export const getCategoryRelatedSearchTiles = ({
    authToken,
    categoryIds,
    concatenatedFacetIds,
    deployment,
}: FetchCategoryRelatedSearchTilesParams) =>
    new Promise<FetchCategoryRelatedSearchTilesResponse>((resolve, reject) => {
        const request = makeGet({
            apiPath: 'v2/related-searches-tiles',
            authToken,
            deployment,
            path: ApiHosts.Category,
        });

        const queryObject: Record<string, any> = {
            'category-id': categoryIds,
        };

        if (concatenatedFacetIds && concatenatedFacetIds.length > 0) {
            queryObject['concatenated-facet-id'] = concatenatedFacetIds;
        }

        request.query(queryObject);

        request.end((err, response) => {
            handleResponseOld({ err, reject, resolve, response });
        });
    });
